package com.mshopsas.enterprise.aiw.scan.utils.player

import kotlinx.browser.document
import org.w3c.dom.HTMLAudioElement

actual class PlatformContext

actual class MediaPlayerController actual constructor(platformContext: PlatformContext) {
    private val audioElement = document.createElement("audio") as HTMLAudioElement

    actual fun prepare(
        pathSource: String,
        listener: MediaPlayerListener
    ) {
        audioElement.src = pathSource
        audioElement.addEventListener("canplaythrough", {
            // Audio is ready to play without interruption
            listener.onReady()
            audioElement.play()
        })

        audioElement.onended = {
            listener.onAudioCompleted()
        }
        audioElement.addEventListener("error", {
            listener.onError()
        })
    }

    actual fun start() {
        audioElement.play()
    }

    actual fun pause() {
        audioElement.pause()
    }

    actual fun stop() {
        // Do nothing
    }

    actual fun isPlaying(): Boolean {
        return !audioElement.paused
    }

    actual fun release() {
        // Do nothing
    }

}
